<template>
    <section class="section section-lg text-center bg-white">
        <div class="container container-wide">
            <div>
                <span class="header-text">Proを特別価格で続けませんか？</span>
            </div>
            <div v-if="pageLoadingIndicator" class="offer-wrapper page-loading-indicator">
                <img src="/images/eowp/animation/loading-spinner.jpg" />
            </div>
            <div class="offer-wrapper" v-else>
                <div class="subheader-text">
                    これまで「英辞郎 on the WEB Pro」をご利用いただき、ありがとうございます。
                    <br>
                    解約前の特別なご案内として、年額コースを20％OFFで継続いただける特典をご用意しました。
                    <br>
                    Proの検索環境をそのまま使い続けたい方は、ぜひご確認ください。
                </div>
                <div class="item-container offer-container">
                    <article class="article">
                        <div class="offer-title-container">
                            <p class="big offer-title">{{this.courseName}}</p>
                            <span class="offer-lure">{{this.discount}}<span class="offer-lure-symbol"> {{this.discountSymbol}} </span>
                                <span class="offer-lure-small">OFF</span>
                            </span>
                        </div>
                            <div class="offer-prices">
                                <span class="big old-price">{{formatPrice(this.oldTotalPrice)}}円 &nbsp;</span>
                                <span class="big new-price">{{formatPrice(this.newTotalPrice)}}円</span>
                                （税込）
                            </div>
                            <!-- These values can be dynamically adjusted within Stripe by changing the coupon. In such cases, be sure to also update this information-->
                            <p class="offer-details" v-if="this.offerDuration == '1年間' && this.discountSymbol == '%'">次回のお支払い額が{{formatPrice(discountAmount)}}円引きになります。</p>
                            <p class="offer-details" v-else>次月{{this.durationInMonths}}回のお支払い額が半額になります。</p>
                            <ul class="pc-ticket-list">
                                <li >・特別価格の適用は次回決済{{this.durationInMonths}}回のみです。次年度以降は通常料金{{formatPrice(this.oldTotalPrice)}}円（税込）で自動継続されます。</li>
                            </ul>
                            <div class="ticket-stub-container">
                                <div class="ticket-stub-punch-left"></div>
                                <div class="ticket-stub"></div>
                                <div class="ticket-stub-punch-right"></div>
                            </div>
                        <div class="sub-button-container offer-button-container">
                            <div class="button offer-button ticket-button" :class="disableElement('button')" v-on:click="acceptOffer()" >
                                この特典を利用
                            </div>
                        </div>
                    </article>
                </div>
            </div>
            <ul class="sp-ticket-list">
                <li >・特別価格の適用は次回決済{{this.durationInMonths}}回のみです。次年度以降は通常料金{{formatPrice(this.oldTotalPrice)}}円（税込）で自動継続されます。</li>    
            </ul>
            <div>
                <span class="header-text">Proで使い続けられる機能</span>
            </div>
            <div class="interest-card-container">
                <div class="interest-card-row">
                    <div class="interest-card">
                        <div class="interest-card-content">
                            <img class="interest-card-image" src="/images/interestCard1.svg">
                            <p class="interest-card-text">広告なし</p>
                            <p class="interest-card-caption">解約すると広告が表示</p>
                        </div>
                    </div>
                    <div class="interest-card-gap"></div>
                    <div class="interest-card">
                        <div class="interest-card-content">
                            <img class="interest-card-image" src="/images/interestCard2.svg">
                            <p class="interest-card-text">120万以上の英和例文データ</p>
                            <p class="interest-card-caption">解約すると閲覧できる例文が大幅減</p>
                        </div>
                    </div>
                </div>
                <div class="interest-card-row">
                    <div class="interest-card">
                        <div class="interest-card-content">
                            <img class="interest-card-image" src="/images/interestCard3.svg">
                            <p class="interest-card-text">2万件登録できる<br>単語帳</p>
                            <p class="interest-card-caption">解約すると登録上限が100件</p>
                        </div>
                    </div>
                    <div class="interest-card-gap"></div>
                    <div class="interest-card">
                        <div class="interest-card-content">
                            <img class="interest-card-image" src="/images/interestCard4.svg">
                            <p class="interest-card-text">小窓モード、あいまい検索など検索を快適にする機能</p>
                            <p class="interest-card-caption">解約すると一部機能が制限</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="sub-button-container">
                <div class="button offer-button" :class="disableElement('button')" v-on:click="acceptOffer()">
                    この特典を利用
                </div>
                <div  class="button cancel-button" :class="disableElement('button')" v-on:click="cancelService()">
                    特典を利用せず、定期購入を停止する
                </div>
            </div>
        </div>
    </section>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
body{
    color: #000000;
}
.section-lg{
    padding-top: 60px;
}
.header-text{
    position: relative;
    display: inline-flex;
    font-size: 28px;
    line-height: 28px;
    color: #000000;
    padding: 0px 0px 30px 0px;
}
.offer-wrapper{
    min-height: 282px;
    max-height: fit-content;
    margin-bottom: 60px;
}
.page-loading-indicator {
    text-align: center;
    position: relative;
    display: inline-flex;
    padding-top: 20px!important;
}
.page-loading-indicator > img {
    margin-top: 30px;
    width: 50px;
    height: 50px;
}
.subheader-text{
    font-size: 18px;
    max-width: 660px;
    margin: auto;
    padding: 0px 0px 30px 0px;
    line-height: 36px;
}
.offer-container{
    width: 660px;
    border-radius: 25px;
    box-shadow: 0px 4px #EFE7E7;
    padding: 30px 20px;
    background: linear-gradient(to top left,  #FFFCFA,#FFE7E7);
    margin: auto;
    margin-bottom: 20px;
    text-align: left;
}

.offer-title-container{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    line-height: 1;
}
.offer-title{
    font-size: 28px;
    font-weight: 700;
    color: #000000;
    margin: 0px;
}
.offer-lure{
    width: fit-content;
    font-size: 70px;
    font-weight: bold;
    color: #971E22;
}
.offer-lure-symbol{
    font-size: 30px;
}
.offer-lure-small{
    font-size: 48px;
}
.offer-prices{
    padding: 0px;
    color: #FF0000;
    font-size: 16px;
}
.old-price{
    color: #666666;
    font-size: 28px;
    font-weight: bold;
    text-decoration: line-through;
}
.new-price{
    color: #FF0000;
    font-size: 28px;
    font-weight: bold;
    padding-left: 10px;
}
.offer-details{
    margin: 20px 0px 0px 0px;
}
ul{
    margin: 20px 0px 16px 0px;
    padding: 0px;
    font-size: 13px;
}
li{
    padding: 5px 0px 0px 2em;
    font-size: 14px;
    text-indent: -1em; /*Dynamically adjusts to font-size, keeping text indented for list */
}
.pc-ticket-list{
    display: flex;
    flex-direction: column;
}
.sp-ticket-list{
    display: none;
}
.ticket-stub-container{
    width: calc(100% + 80px);
    height: 30px;
    transform: translate(-40px,0);
    display: flex;
    flex-direction: row;
}
.ticket-stub-punch-left,
.ticket-stub-punch-right{
    height: 30px;
    width: 40px;
    border-radius: 20px;
    background: white;
}
.ticket-stub-punch-left{
    left: 0;
}
.ticket-stub-punch-right{
    right: 0;
}
.ticket-stub{
    width: calc(100% - 40px);
    height: 50%;
    margin-top: 12.5px;
    overflow: hidden;
    border-top: 5px dotted white;
}
.interest-card-container{
    max-width: 660px;
    display: flex;
    flex-direction: column;
    margin: auto;
}
.interest-card-row{
    margin: 0px 0px 20px 0px;
    display: flex;
    flex-direction: row;
}
.interest-card-gap{
    width: 20px;
}
.interest-card{
    display: grid;
    width: 320px;
    height: 317px;
    border-radius: 25px;
    background:#FAFAFA;
}
.interest-card-content{
    justify-content: space-between;
    justify-self: center;
    align-self: center;
    margin: 20px;
}
.interest-card-text{
    margin: 0px 0px 20px 0px;
    padding: 10px 0px;
    font-size: 20px;
}
.interest-card-caption{
    border-top: solid 1px #EEEEEE;
    padding-top: 20px;
    max-width: 240px;
    margin: auto;
    font-size:18px;
}
.button-disabled{
    background-color: #dddddd!important;
    color: #bbbbbb!important;
    border-color: #dddddd!important;
    pointer-events: none;
    cursor: default;
}
.sub-button-container {
    text-align: center;
    margin: 40px 0px 0px 0px;
    padding: 0px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    max-width: 660px;
    margin: auto;
}
.offer-button-container{
    padding: 0px !important;
    display: block;
    margin: 13px auto 0px;
}
.offer-button,
.cancel-button{
    display: grid;
    justify-self: center;
    place-items: center;
    margin: 10px;
    width: 320px;
    height: 56px;
    font-size: 18px;
    line-height: 20px;
}
.offer-button{
    background: #971E22;
    font-weight: bold;
    color: #FAFAFA;
    border: none;
}
.cancel-button{
    font-size: 14px;
    font-weight: 700;
    padding: 10px 10px;
}
@media screen and (max-width: 669px){
body{
    font-size: 14px;
}
.header-text{
    font-size: 20px;
    line-height: 20px;
    padding: 0px;
}
.subheader-text{
    font-size: 12px;
    margin: 20px 0px;
    padding: 0px;
    line-height: 24px;
}
.offer-wrapper{
    margin-bottom: 16px;
}
.offer-container{
    width: 100%;
    margin: 0px;
}
.offer-title{
    font-size: 16px;
    font-weight: bold;
    margin: 0px;
    padding: 0px 0px 20px 0px;
}
.offer-lure{
    font-size: 35px;
}
.offer-lure-symbol{
    font-size: 12px;
}
.offer-lure-small{
    font-size: 24px;
}
.offer-prices{
    padding: 0px;
    font-size: 12px;
}
.old-price{
    font-size: 16px;
}
.new-price{
    font-size: 16px;
}
.offer-details{
    margin: 15px 0px 0px 0px;
}
ul{
    font-size: 14px;
}
li{
    font-size: 14px;
}
.pc-ticket-list{
    display: none;
}
.sp-ticket-list{
    display: flex;
    flex-direction: column;
    text-align: left;
    font-size: 12px;
    padding: 0px;
    margin: 0px 0px 40px 0px;
}
.interest-card-container{
    max-width: 660px;
    display: flex;
    flex-direction: column;
    margin: auto;
}
.interest-card-row{
    display: flex;
    flex-direction: column;
    margin: 0px;
}
.interest-card-gap{
    width: 5px;
}
.interest-card{
    margin: 20px 20px 0px 20px;
    width: auto;
    height: auto;
    border-radius: 25px;
    background: #FAFAFA;
}
.interest-card-text{
    font-size: 16px;
    margin: 0px;
    padding: 16px 0px;
}
.interest-card-caption{
    font-size: 14px;
    padding: 16px 0px 0px 0px;
}
.sub-button-container{
    flex-direction: column;
    max-width: 75%;
    padding: 0px !important;
    margin: 40px auto 0px auto;
}
.offer-button-container{
    padding: 0px !important;
    margin: 16px 0px 0px 0px;
}
.offer-button,
.cancel-button{
    max-width: none;
    width: 100%;
    height: 40px;
    margin: 0px;
    justify-self: auto;
}
.ticket-button{
    margin: 0px 20%;
}
.cancel-button{
    margin: 20px 0px;
    font-size: 11px;
}
}
@media screen and (max-width: 360px){
.offer-title{
    font-size: 14px;
}
ul{
    font-size: 13px;
}
li{
    font-size: 13px;
}
.sub-button-container{
    max-width: none;
}
.offer-button,
.cancel-button{
    max-height: fit-content;
    height: 100%;
    margin: 10px 0px;
    font-size: 14px;
}
.ticket-button{
    margin: 13px 0px 0px 0px;
}
.cancel-button{
    margin: 20px 0px;
    padding: 0px;
    max-height: none;
    font-size: 11px;
}
.button{
    padding: 10px 10px;
    min-width: 0px;
}
}
</style>

<script>
import { mapActions, mapGetters } from "vuex";
import CouponManager from '../../js/helpers/CouponManager';
import DialogMixin from '../../js/helpers/mixins/DialogMixin';
import Utils from '../../js/helpers/Utils';
import ShopConstants from '../../js/helpers/ShopConstants';


export default {
    data() {
        return {
            pageLoadingIndicator: false,
            buttonDisabledForProcessing: false,
            csMatNo:'',
            courseName: '',
            couponId: '',
            discount: '0',
            discountSymbol:'',
            oldBasePrice: 0,
            newBasePrice: 0,
            oldTotalPrice: 0,
            newTotalPrice: 0,
            duration: "once",
            durationInMonths: 1,
            offerDuration:'',
            offerEndTimeFrame:'',
            isUpdateSubscriptionInProgress: false,
            eowp: {
                products: {
                    monthly: {
                        item: [],
                        ref: 'EOWP_MONTHLY_ITEM'
                    },
                    yearly: {
                        item: [],
                        ref: 'EOWP_YEARLY_ITEM'
                    },
                    yearlyS: {
                        item: [],
                        ref: 'EOWP_YEARLY_S_ITEM'
                    },
                    subTypeRef: {
                        'EOWP_MONTHLY_ITEM': 'MONTHLY',
                        'EOWP_YEARLY_ITEM': 'YEARLY',
                        'EOWP_YEARLY_S_ITEM': 'YEARLY',
                    },
                    forcePayment: {
                        MONTHLY: true
                    },
                },
                subscription: [],
                subscriptionType: '',
                useStatuses: {
                    active: 1,
                    switched: 3
                },
                updateSubscriptionMessage: {
                    ERROR1: {
                        title: '予期せぬエラーが発生しました', //Unexpected Error Occurred
                        body: 'リクエストの転送中に予期せぬエラーが発生しました。ページを開き直して再度お試しください。', //An unexpected error has occurred while forwarding request. Please refresh the page and try again.
                        option: 'refreshPageOptions'
                    },
                    ERROR28: {
                        title: 'エラーが発生しました', //An Error Occurred
                        body: 'サブスクリプションを停止できませんでした。 もう一度やり直してください。', //Failed to stop the subscription. Please try again
                        option: 'refreshPageNetworkErrorOptions'
                    },
                    DEFAULT_ERROR: {
                        title: '更新に失敗しました', //Update Failed
                        body: '契約内容の切り替えに失敗しました。再度試しても解決しない場合は、以下の情報を添えてお問い合わせください。', //Switching current subscription state failed, Please refresh the current page and try again. If this problem persist, please contact the admin with error reference',
                        option: 'refreshPageNetworkErrorOptions'
                    },
                },
            },
            dialogParams: {
                defaultOptions: {
                    loader: false,
                    okText: 'OK',
                    cancelText: 'キャンセル', //Cancel
                    animation: 'zoom',
                    backdropClose: true
                },
            },
        };
    },
    computed: {
        ...mapGetters({
            user: 'user/user',
            sessionDetails: 'user/session_details',
            pathIntention: 'user/path_intention',
            userSessionId: 'user/session',
            products: 'ncs/products',
            currentSubscription: 'ncs/current_subscription',
        }),
        discountAmount() {
            return Math.max(0, this.oldTotalPrice - this.newTotalPrice);
        },
    },
    methods: {
        ...mapActions({
            setPathIntention: 'user/setPathIntention',
            fetchSessionDetails: 'user/fetchSessionDetails',
            retrieveProducts: 'ncs/retrieveProducts',
            getNewPrice: 'coupon/getNewPrice',
            saveCouponId: 'coupon/saveCouponId',
            getCouponId: 'coupon/getCouponId',
            setChosenItem: 'ncs/setChosenItem',
            trackClickEvent: 'ga/trackClickEvent',
            updateSubscriptionStatus: 'pg/updateSubscriptionStatus',
            getCurrentSubscription: 'ncs/getCurrentSubscription',
        }),
        formatPrice(price){
            return Utils.formatNumber(price);
        },
        fetchDuration(){
            if(this.isYearlyOfferTarget()){
                this.offerDuration = "1年間";
            }
            else if(this.durationInMonths == 1 || this.duration == 'once'){
                    this.offerDuration = "1カ月";
                }
            else{
                this.offerDuration = this.durationInMonths + "カ月連続で";
            }
        },
        handleDiscountFormat(amount_off, percent_off){
            if(amount_off != null){
                this.discount = parseInt(amount_off);
                this.discountSymbol = "円";
            }
            else if (percent_off != null){
                this.discount = parseInt(percent_off);
                this.discountSymbol = "%";
            }
        },
        calculateOfferEndTimeFrame(){
            if(this.isYearlyOfferTarget()){
                this.offerEndTimeFrame = "1年間";
            }
            else if(this.durationInMonths == 1 || this.duration == 'once'){
                this.offerEndTimeFrame = "2カ月";
                }
            else{
                var durationPlusOne = (this.durationInMonths + 1)
                this.offerEndTimeFrame = durationPlusOne + "カ月";
            }
        },
        disableElement(flag) {
            let clazz = flag + '-disabled';
            return  this.buttonDisabledForProcessing ? clazz : '';
        },
        getProductByItemType(itemType){
            if (!this.products) return null;
            return this.products.find(product => product.itemType == itemType);
        },
        getYearlyOfferProduct(){
            const yearlyProduct = this.getProductByItemType(this.eowp.products.yearly.ref);
            return yearlyProduct || (!Utils.isEmpty(this.eowp.products.yearly.item) ? this.eowp.products.yearly.item : null);
        },
        isMonthlyCurrentSubscription(){
            if (Utils.isEmpty(this.currentSubscription)) return false;
            const currentProduct = this.products.find(product => product.csMatNo == this.currentSubscription.csMatNo);
            return currentProduct && currentProduct.itemType == this.eowp.products.monthly.ref;
        },
        resolveStopIntentOfferCsMatNo(){
            if (Utils.isEmpty(this.currentSubscription)) return '';

            const yearlyProduct = this.getYearlyOfferProduct();
            if (this.currentSubscription.useStatus == '3' || this.isMonthlyCurrentSubscription()) {
                return yearlyProduct ? yearlyProduct.csMatNo : this.currentSubscription.csMatNo;
            }
            return this.currentSubscription.csMatNo;
        },
        isYearlyOfferTarget(){
            const targetProduct = this.products.find(product => product.csMatNo == this.csMatNo);
            return targetProduct && targetProduct.itemType == this.eowp.products.yearly.ref;
        },
        async cancelService() {
            this.buttonDisabledForProcessing = true;
            if(!await this.checkActiveSession()) return;
            // Retrieve user's current subscription
            await this.getCurrentSubscription(this.sessionDetails.userId).then(() => {
                this.eowp.subscription = !Utils.isEmpty(this.currentSubscription) ? this.currentSubscription : {};
            });
            await this.$dialog.confirm({
                    title: '確認',
                    body: 'サブスクリプションを停止してよろしいですか？',
                }, this.dialogParams.defaultOptions)
            .then(() => {
                this.isUpdateSubscriptionInProgress = true;
                let userId = this.sessionDetails.userId;
                let sessionId = this.sessionDetails.sessionId;
                let orderNo = this.eowp.subscription.csOrderNo;
                let request = 'stop';
                this.updateSubscriptionStatus({
                    userId: userId,
                    sessionId: sessionId,
                    csOrderNo: orderNo,
                    request: request
                }).then(res => {
                    if (res.status_code == "ERROR2") {
                        this.$router.push("/signin");
                    } else if (res.status_code == "SUCCESS" || (res.responseCode == "200" && res.resultCode == "0")) {
                        // Once the update is successfully saved, send the user back to the survey page
                        this.$router.push("/survey");
                    }
                    else {
                        let errorRef = this.eowp.updateSubscriptionMessage[res.status_code];
                        if (!errorRef) errorRef = this.eowp.updateSubscriptionMessage['DEFAULT_ERROR'];
                        let errorParams = { error: { reference: errorRef, status_code: res.status_code } };
                        this.errorMessage(errorParams);
                    }
                    this.trackOfferPageEvents('offer_cancel_subscription');
                    this.isUpdateSubscriptionInProgress = false;
                }).catch(() => {});
            }).catch(() => {
                this.buttonDisabledForProcessing = false;
            });
        },
        errorMessage(res){
            if(res.error) {
                let statusCodes = new Array();
                if(res.error.status_code) statusCodes.push("StatusCode: " + res.error.status_code);
                if(res.error.responseCode) statusCodes.push("ResponseCode: " + res.error.responseCode);
                if(res.error.resultCode) statusCodes.push("ResultCode: " + res.error.resultCode);
                let finalStatusCodes = statusCodes.length > 0 ? statusCodes.join(",") : "";
                let errorRef = res.error.reference;
                this.$dialog.alert({
                    title: errorRef.title,
                    body: errorRef.body + " [" + finalStatusCodes + "]",
                }, this.dialogParams[errorRef.option])
                .then(() => window.location.reload())
                .catch(() => {});
            }
        },
        trackOfferPageEvents(eventName){
            this.trackClickEvent({event: eventName, path: this.$route.path, title: this.$route.meta.title});
        },
        getCourseName(csMatNo){
            if (Object.prototype.hasOwnProperty.call(ShopConstants.COURSE_MAPPING, csMatNo)) {
                return ShopConstants.COURSE_MAPPING[csMatNo];
            }
            return "";
        },
        async acceptOffer(){
            if(!await this.checkActiveSession()) return;
            await this.saveCouponId(this.couponId);
            this.setChosenItem(this.csMatNo);
            this.setPathIntention('');
            this.$router.push('/basket');
        }
    },
    async created() {
        // Allow access only if the user reached this page via the cancellation flow in the account page.
        if (this.pathIntention !== '/offer') {
            // Not coming from the expected flow – send back to account page.
            this.$router.push('/account');
            return;
        }
        // NOTE: We intentionally keep the flag while the user is on this page so that a full page
        // reload (which re-hydrates Vuex from localStorage) still contains '/offer' and the guard
        // passes again. The flag will be cleared when the user navigates away from this component
        // (see beforeRouteLeave hook below).
        this.pageLoadingIndicator = true;
        if(this.userSessionId && !this.sessionDetails){
            await this.fetchSessionDetails(this.userSessionId);
            if(!this.sessionDetails){
                this.$router.push("/signin");
            }
        }
        try{
            if (!this.products || this.products.length == 0) {
                await this.retrieveProducts();
            }
            if (!this.currentSubscription) {
                await this.getCurrentSubscription(this.sessionDetails.userId);
            }
            this.csMatNo = this.resolveStopIntentOfferCsMatNo();
            const currentProduct = this.products.filter(product => product.csMatNo == this.csMatNo);
            if (currentProduct.length == 0) {
                throw new Error("Offer target product not found");
            }
            const basePrice = currentProduct.length > 0 ? currentProduct[0].productPrice : '';
            const totalPrice = currentProduct.length > 0 ? currentProduct[0].productPriceWithTax : '';
            this.oldBasePrice = basePrice;
            this.oldTotalPrice = totalPrice;
            const merchantPrice = currentProduct.length > 0 ? currentProduct[0].merchantProductPrice : '';
            const promoId = '';
            //  Here we will check get the coupon by asking Stripe for all coupons with StopIntent Metadata, then we will narrow it down to just the one(s) for our CsMatno
            const couponManager = new CouponManager(this);
            const couponIdResponse = await couponManager.getCouponId(this.csMatNo, 'stop_intent');
            this.couponId = couponIdResponse.data.coupon_id;
            const response = await couponManager.getNewPrice(basePrice, merchantPrice, promoId, this.couponId, totalPrice);
            if (response.status_code == 200) { //Checks for a 200 response from the getNewPrice call
                this.newBasePrice = response.data.base_price;
                this.newTotalPrice = response.data.new_total_price;
                this.duration = response.data.duration;
                this.durationInMonths = response.data.duration_in_months;
                this.handleDiscountFormat(response.data.amount_off, response.data.percent_off);
                this.fetchDuration();
                this.calculateOfferEndTimeFrame();
                this.courseName = this.getCourseName(this.csMatNo);
            }
            else { //if not 200 (meaning 400 or 500) from getNewPrice call, go back to the account page and show the error
                this.$router.push({
                    path: '/account',
                    query: { offerLoadFailed: 'true'}
                });
            }
        }catch(error)
        {
            this.$router.push({
                path: '/account',
                query: { offerLoadFailed: 'true'}
            });
        }
        this.pageLoadingIndicator = false;
    },
    beforeRouteLeave (to, from, next) {
        // Clean up navigation intent when the user leaves the Offer page so it doesn't interfere
        // with other flows.
        this.setPathIntention('');
        next();
    },
    mixins: [
        DialogMixin
    ]
};
</script>
